import * as angular from 'angular';
import { adminAccountsDashboardComponent } from './admin-accounts-dashboard.component';
import { topLevelAdminAccountsComponent } from './top-level-admin-accounts.component';

export const AdminAccountsModule = angular.module('adminAccountsModule', [])
    .component('topLevelAdminAccounts', topLevelAdminAccountsComponent)
    .component('adminAccountsDashboard', adminAccountsDashboardComponent)
    .name;
